import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { UniverseComponent } from 'src/domains/common/universes';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    SuccessOverlayWrapper,
    SuccessOverlayLogo,
    SuccessOverlayIcon,
    SuccessOverlayText,
    SuccessOverlayParagraph,
    SuccessOverlayButtonWrapper,
} from './SuccessOverlay.style';

interface SuccessOverlayProps {
    onClose: () => void;
}

export const SuccessOverlay = observer('SuccessOverlay', ({ onClose }: SuccessOverlayProps) => {
    return (
        <SuccessOverlayWrapper data-test='id-mission-success-overlay'>
            <SuccessOverlayLogo>
                <UniverseComponent>
                    {(universeVersion): React.ReactElement => <universeVersion.headerLogo />}
                </UniverseComponent>
            </SuccessOverlayLogo>
            <SuccessOverlayIcon />
            <SuccessOverlayText>
                <SuccessOverlayParagraph>
                    <I18n
                        langKey='id-mission.success.text-1'
                        defaultText='Thank you for completing our identification checks.'
                    />
                </SuccessOverlayParagraph>
                <SuccessOverlayParagraph>
                    <I18n
                        langKey='id-mission.success.text-2'
                        defaultText='Your account has been successfully verified.'
                    />
                </SuccessOverlayParagraph>
            </SuccessOverlayText>
            <SuccessOverlayButtonWrapper>
                <Button
                    size='medium'
                    onClick={onClose}
                >
                    <I18n
                        langKey='id-mission.success.button'
                        defaultText='Continue'
                    />
                </Button>
            </SuccessOverlayButtonWrapper>
        </SuccessOverlayWrapper>
    );
});
